<template lang="pug">
  div.stu-footer
    div
      p.fl.text-ct
        span.fl
          a.fl.f12.grey9(href='/static/page/youngsters.html' target='_blank') {{ $t('footer.youth') }}
          hr
        span.fl
          a.fl.f12.grey9(href='/static/page/declare.html' target='_blank') {{ $t('footer.declare') }}
          hr
        //- span.fl
        //-   a.fl.f12.grey9(href='/static/page/private.html' target='_blank') {{$t('footer.private')}}
        //-   hr
        span.fl.f12.grey9
          | {{ copyright + cfName + $t('footer.copyright') }}
          hr
        span.fl.f12.grey9
          a.f12.grey9(href='http://beian.miit.gov.cn' target='_blank') {{ icp }}
        span.fl.f12.gong-an(v-if='icon')
          a.f12.grey9(:href='"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" + police' target='_blank' name='abc') 苏公网安备{{police}}号
      div.browser
        a.f12.grey9(href='http://18ks.chivoxapp.com/guide/360Browse.exe') 
          img.fl(src='@/assets/images/icon_browser-360.png' alt='360')
          | {{ $t('footer.browser360') }}
        a.f12.grey9(href='http://18ks.chivoxapp.com/guide/QQBrowser.exe')
          img.fl(src='@/assets/images/icon_browser-qq.png' alt='QQ')
          | {{ $t('footer.browserqq') }}
</template>

<script>
export default {
  name: 'Footer',
  data() {
    const { cfName } = window.ConfigNew.header
    const { copyright, icp, police, icon } = window.ConfigNew.footer
    return {
      cfName,
      copyright,
      icp,
      police,
      icon
    }
  },
  mounted() {
    window.renderFooter()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/components/footer.vue